export enum colorClasses {
    ok = 'ok',
    offline = 'offline',
    warning = 'warning',
    caution = 'caution',
    lbalck = 'header-black'
}
